import * as Yup from 'yup';

/**
 * Validation for the payment intent form.
 *
 * ═══ MONEY PATH: `amount` IS A NUMBER IN MINOR UNITS ═══
 *
 * It was `Yup.string().required()`. The schema declares `amount: Int!`, so a
 * string was being validated as valid and then sent where an Int is expected.
 * Worse, `Yup.string()` accepts "12abc" and " " — neither is a number, and
 * neither was caught before the mutation went out.
 *
 * ⚠️ THE UNIT IS DELIBERATELY UNCHANGED. The value entered here is transmitted
 * to `CreatePaymentIntentInput.amount` verbatim, which Stripe reads as MINOR
 * UNITS — 1000 means $10.00. That is how `payment-flow-tester` already builds
 * its intents (`useState<number>(1000)`), so the two agree.
 *
 * Making the form take major units and multiply by 100 on write would change
 * what a given keystroke charges, which is a money-movement change and out of
 * scope for FNP-918. The field LABEL now states the unit instead (see
 * FormComponent.tsx) so the existing behaviour is at least legible. If the
 * major-unit input is wanted, it needs its own ticket and its own approval.
 *
 * `integer()` and `min(1)` are enforced because Stripe rejects both a fractional
 * amount and a zero/negative one — better a form error than a failed mutation.
 */
export const RecordSchema = Yup.object()
                               .shape({
                                          amount: Yup.number()
                                                     .typeError('Amount must be a number, in minor units (e.g. 1000 = 10.00)')
                                                     .integer('Amount must be a whole number of minor units')
                                                     .min(1, 'Amount must be greater than zero')
                                                     .required('Required'),
                                          currency: Yup.string()
                                                       .required('Required'),
                                          paymentMethod: Yup.string(),
                                          customerId: Yup.string()
                                                         .required('Required'),
                                          description: Yup.string(),
                                      });
